import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  field: {
    flex: 1,
    minWidth: 0
  },
  summary: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    marginTop: 6
  }
});
export default useStyles;